"use client"
import React, { useState } from 'react'
import { ArrowUpRight, Play, X } from "lucide-react";
import WhyMSUModal from '../WhyMSU/WhyMSUModal';
import button from "@//assets/banner/Group 4 (1).svg"
import Image from 'next/image';

const AboutWhowe = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const videoUrl = "https://cdn.msu.edu.in/MSU_Infra_1_6d3df9a1ca.mp4";
    const videoTitle = "Medhavi Skills University Overview";

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    return (
        <section className="w-full mt-14  bg-white">
            <div className="grid xl:grid-cols-2 gap-10 ">

                <div className="pt-10">
                    <h2
                        className="text-2xl lg:text-[42px] font-extrabold text-gray-900 mt-4"
                        style={{ fontFamily: "saans-bold" }}
                    >
                        Medhavi Skills University (MSU)
                    </h2>

                    <p className="text-gray-700 text-base sm:text-[18px] leading-relaxed mt-4"
                        style={{ fontFamily: "saans-regular" }}
                    >
                        Medhavi Skills University (MSU), Sikkim, chartered under the Sikkim Act 2021 and recognised by UGC in 2022, is India’s first skill-based university integrating NEP 2020 in an industry-led format. Founded by IIT-Kharagpur and Stanford alumnus Shri Pravesh Dudani (Founder & Chancellor) and educationist Shri Kuldip Sarma (Co-Founder & Pro-Chancellor), MSU bridges skilling with higher education through its pioneering WISE initiative and extensive industry collaborations.
                    </p>

                    <p className="text-gray-700 text-base sm:text-[18px] leading-relaxed mt-4"
                        style={{ fontFamily: "saans-regular" }}
                    >
                        With 650+ industry and skilling partners, MoUs with Indian defense forces, and recognition from NSDC and NCVET, MSU offers work-integrated, industry-driven learning. Ranked 4th in the Outlook ICARE rankings 2025 and recognised as the emerging university of India by the Financial Express, the University is helping India build the skilled workforce for an Atmanirbhar Bharat.
                    </p>
                    <button
                            onClick={() => window.open("/why-medhavi-skills-university")}
                            className="group mt-6 inline-flex items-center cursor-pointer w-[280px] justify-center bg-[#081E2D] text-white text-[11px] md:text-sm font-medium px-4 py-2 md:px-6 md:py-3"
                            style={{ fontFamily: "saans-bold" }}
                            >
                            <span>Know more about MSU</span>
                            <ArrowUpRight
                                className="ml-2 rotate-45 group-hover:-rotate-0 h-6 w-6 transition-transform duration-300"
                                strokeWidth={2.2}
                            />
                    </button>

                </div>
                <div className=" w-full ">
                    <div
                        className="relative aspect-auto md:h-[70vh] h-[50vh] w-full md:mt-12 overflow-hidden  border border-gray-100 cursor-pointer group transform hover:scale-[1.01] transition duration-500 ease-in-out bg-gray-200 flex items-center justify-center"
                        role="button"
                    >
                        <div className="absolute inset-0 bg-cover bg-center transition-opacity duration-500 group-hover:opacity-80 opacity-100"
                            style={{
                                backgroundImage: `url(https://cdn.msu.edu.in/msu-reavamp/who-we-are-img/MSU_11zon.png)`,
                            }}
                        />
                    </div>
                </div>
            </div>

            {isModalOpen && (
                <WhyMSUModal
                    videoUrl={videoUrl}
                    videoTitle={videoTitle}
                    setOpen={closeModal}
                />
            )}
        </section>
    );
}

export default AboutWhowe;